
document.addEventListener('DOMContentLoaded', function () {
  const pickupDateInput = document.getElementById('pickup-date');
  const pickupLocationSelect = document.getElementById('pickup-location');
  const pickupErrorBox = document.getElementById('pickup-error');
  const pickupLocationNote = document.getElementById('pickup-location-note');
  const locationsScript =
    document.getElementById('pickup-locations-json') ||
    document.getElementById('pickup-location-json') ||
    document.getElementById('pickupLocationsJson');

  if (!pickupDateInput || !pickupLocationSelect || !locationsScript) return;

  // Flatpickr wird ausschließlich durch pickup-flatpickr.js initialisiert.
  const dateWrapper =
    pickupDateInput.closest('.pickup-section__control--date') ||
    pickupDateInput.parentElement;

  if (dateWrapper) {
    dateWrapper.addEventListener('click', function (event) {
      if (event.target === pickupDateInput) return;
      if (pickupDateInput._flatpickr) {
        pickupDateInput._flatpickr.open();
      } else {
        pickupDateInput.focus();
      }
    });
  }

  // -----------------------------
  // Filialkonfiguration einlesen
  // -----------------------------
  let config = {};
  try {
    config = JSON.parse(locationsScript.textContent || '{}');
  } catch (error) {
    console.error('[Pickup] Fehler beim Parsen der Filialkonfiguration:', error);
    return;
  }

  const allLocations = Array.isArray(config.locations) ? config.locations : [];

  // -----------------------------
  // Produktspezifische Filialbeschränkungen
  // -----------------------------
  // null = keine Filialbeschränkung
  // Set = erlaubte Filial-IDs

  function readAllowedLocationIds() {
    const restrictedItems = document.querySelectorAll(
      '.cart-item[data-allowed-pickup-locations]'
    );

    if (!restrictedItems.length) return null;

    let common = null;

    for (const item of restrictedItems) {
      let ids;

      try {
        ids = JSON.parse(
          item.getAttribute('data-allowed-pickup-locations') || 'null'
        );
      } catch (error) {
        console.error('[Pickup] Ungültige Filialliste im Warenkorb:', error);
        return new Set();
      }

      if (!Array.isArray(ids)) return new Set();

      const current = new Set(
        ids.map(id => String(id).trim()).filter(Boolean)
      );

      common = common === null
        ? current
        : new Set([...common].filter(id => current.has(id)));
    }

    return common;
  }

  // Nur die erlaubten Filialen bereitstellen
  function availableLocations() {
    const allowedIds = readAllowedLocationIds();

    if (allowedIds === null) return allLocations;

    return allLocations.filter(loc =>
      allowedIds.has(String(loc.id).trim())
    );
  }

  const locations = availableLocations();

  // -----------------------------
  // Filialauswahl befüllen
  // -----------------------------
  const originallySelected =
    pickupLocationSelect.dataset.selectedLocation || '';

  function populateLocations() {
    pickupLocationSelect.innerHTML = '';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Bitte Filiale wählen…';
    pickupLocationSelect.appendChild(placeholder);

    locations.forEach(loc => {
      const option = document.createElement('option');
      option.value = String(loc.id);
      option.textContent = loc.name;
      pickupLocationSelect.appendChild(option);
    });

    // Gespeicherte Filiale nur übernehmen,
    // wenn sie weiterhin erlaubt ist
    const validStored = locations.some(
      loc => String(loc.id) === originallySelected
    );

    pickupLocationSelect.value = validStored
      ? originallySelected
      : (locations.length === 1 ? String(locations[0].id) : '');

    syncLocationDetails();
  }

  function selectedLocation() {
    return locations.find(
      loc => String(loc.id) === pickupLocationSelect.value
    );
  }

  function syncLocationDetails() {
    const location = selectedLocation();

    const nameInput =
      document.getElementById('pickup-location-name');

    const addressInput =
      document.getElementById('pickup-location-address');

    if (nameInput) {
      nameInput.value = location ? location.name || '' : '';
    }

    if (addressInput) {
      addressInput.value = location ? location.address || '' : '';
    }
  }

  populateLocations();

  // -----------------------------
  // Keine gemeinsame Abholfiliale
  // -----------------------------
  if (
    pickupLocationNote &&
    readAllowedLocationIds() !== null &&
    locations.length === 0
  ) {
    pickupLocationNote.textContent =
      'Für die Artikel in deinem Warenkorb gibt es keine gemeinsame Abholfiliale. Bitte passe deinen Warenkorb an.';
  }

  // -----------------------------
  // Öffnungstage der Filiale prüfen
  // -----------------------------
  function isLocationOpenOnDate(locationId, dateString) {
    const location = locations.find(
      loc => String(loc.id) === locationId
    );

    if (!location) return false;

    const date = new Date(dateString + 'T00:00:00');

    if (Number.isNaN(date.getTime())) return false;

    const openWeekdays = location.weekday_open || [];
    const closedDates = location.closed_dates || [];

    return (
      openWeekdays.includes(date.getDay()) &&
      !closedDates.includes(dateString)
    );
  }

  // -----------------------------
  // Produktspezifische Abholdaten
  // -----------------------------
  function restrictedProducts() {
    return [
      ...document.querySelectorAll(
        '.cart-item[data-allowed-dates]'
      )
    ].map(item => {
      let dates = [];

      try {
        const parsed = JSON.parse(
          item.dataset.allowedDates || '[]'
        );

        if (Array.isArray(parsed)) {
          dates = parsed;
        }
      } catch (error) {
        console.warn(
          '[Pickup] Fehler beim Lesen der erlaubten Abholdaten:',
          error
        );
      }

      return {
        title: item.dataset.productTitle || 'Dieses Produkt',
        dates
      };
    });
  }

  // -----------------------------
  // Abholdatum prüfen
  // -----------------------------
  function validateDateForSelectedLocation(showMessage) {
    const date = pickupDateInput.value;
    const locationId = pickupLocationSelect.value;

    if (!date || !locationId) return true;

    const allowed = availableLocations().some(
      loc => String(loc.id) === locationId
    );

    const open =
      allowed && isLocationOpenOnDate(locationId, date);

    if (pickupLocationNote && showMessage) {
      pickupLocationNote.textContent = allowed
        ? (
            open
              ? ''
              : 'An diesem Datum hat die gewählte Filiale geschlossen. Bitte wähle ein anderes Datum oder eine andere Filiale.'
          )
        : 'Diese Filiale ist für deinen Warenkorb nicht verfügbar.';
    }

    return open;
  }

  // -----------------------------
  // Events: Filial- und Datumswechsel
  // -----------------------------
  pickupLocationSelect.addEventListener('change', function () {
    syncLocationDetails();

    if (pickupLocationNote) {
      pickupLocationNote.textContent = '';
    }

    if (pickupDateInput.value) {
      validateDateForSelectedLocation(true);
    }
  });

  pickupDateInput.addEventListener('change', function () {
    validateDateForSelectedLocation(true);
  });

  // Automatisch ausgewählte Filiale an
  // das Kalender-Script übergeben
  if (pickupLocationSelect.value !== originallySelected) {
    window.addEventListener('load', function () {
      pickupLocationSelect.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }, { once: true });
  }

  // -----------------------------
  // Checkout-Validierung
  // -----------------------------
  const cartForm = document.getElementById('cart');

  if (!cartForm) return;

  // Unsere eigene Prüfung zeigt die Fehlermeldungen
  pickupLocationSelect.required = false;
  pickupDateInput.required = false;

  cartForm.addEventListener('submit', function (event) {
    if (pickupErrorBox) {
      pickupErrorBox.style.display = 'none';
      pickupErrorBox.textContent = '';
    }

    const date = pickupDateInput.value;
    const locationId = pickupLocationSelect.value;

    const currentAvailable = availableLocations();

    const isAllowed = currentAvailable.some(
      loc => String(loc.id) === locationId
    );

    const errors = [];

    // Prüfen, ob eine gemeinsame Abholfiliale existiert
    if (currentAvailable.length === 0) {
      errors.push(
        'Für diese Produkte gibt es keine gemeinsame Abholfiliale. Bitte passe deinen Warenkorb an.'
      );
    } else if (!locationId) {
      errors.push('Bitte eine Filiale auswählen.');
    } else if (!isAllowed) {
      errors.push(
        'Die gewählte Filiale ist für mindestens einen Artikel nicht erlaubt. Bitte wähle eine verfügbare Filiale.'
      );
    }

    // Prüfen, ob ein Datum gewählt wurde
    if (!date) {
      errors.push('Bitte ein Abholdatum auswählen.');
    }

    // Öffnungstage prüfen
    if (
      date &&
      isAllowed &&
      !isLocationOpenOnDate(locationId, date)
    ) {
      errors.push(
        'An diesem Datum hat die gewählte Filiale geschlossen. Bitte Filiale oder Datum ändern.'
      );
    }

    // Produktspezifische Abholtage prüfen
    for (const product of restrictedProducts()) {
      if (
        product.dates.length &&
        date &&
        !product.dates.includes(date)
      ) {
        errors.push(
          `${product.title} ist nur an folgenden Tagen abholbar: ${product.dates.join(', ')}.`
        );
      }
    }

    // -----------------------------
    // Fehler anzeigen und Checkout verhindern
    // -----------------------------
    if (errors.length) {
      event.preventDefault();

      if (pickupErrorBox) {
        errors.forEach((message, index) => {
          if (index) {
            pickupErrorBox.appendChild(
              document.createElement('br')
            );
          }

          pickupErrorBox.appendChild(
            document.createTextNode(message)
          );
        });

        pickupErrorBox.style.display = 'block';

        pickupErrorBox.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  });
});
